export const initializeTracking = (allid: string, leadId: string) => {
    const { siteSection, pageName } = buildPageName();
    if (siteSection === 'guideme') {
        return;
    }
    const SessionContext = {
        ...sessionContext,
        ...{
            page: {
                section: siteSection,
                name: pageName,
            },
        },
    };

    if (allid) {
        SessionContext.static.allianceId = allid;
    }
    if (leadId) {
        SessionContext.leadInfo.leadId = leadId;
    }
    // set window variable with session context to override ehmp siteGroup in login/tool modals
    window.__ANALYTICS_DATA__ = SessionContext;
};

export const sessionContext = {
    sysEnv: {
        siteGroup: 'EHI',
    },
    page: {},
    static: {} as Record<string, string>,
    form: {},
    leadInfo: {} as Record<string, string>,
    marketing: {},
    profile: {},
    quote: {},
    search: {},
    shop: {},
    sort: {},
    user: {},
    video: {},
};

function buildPageName() {
    const pathName = typeof window !== 'undefined' ? window.location.pathname : '';
    const splitPathArr = pathName.split('/').filter(function (item) {
        return !!item;
    });
    const pagePath = splitPathArr.filter((word) => word !== 'medicare');
    let pageName = pagePath.length > 1 ? pagePath[pagePath.length - 1] : pagePath[0];
    let siteSection =
        pagePath.includes('blog') && pagePath.length === 2
            ? pagePath[0] + ':category'
            : pagePath[0];

    switch (pathName) {
        case '/':
            pageName = 'home';
            siteSection = 'homepage';
            break;
        case '/online/':
            pageName = 'home';
            siteSection = 'homepage';
            break;
        case '/404/':
            pageName = 'error';
            break;
        case '/online/404/':
            pageName = 'error';
            break;
        case '/articles/':
            break;
        case '/online/articles/':
            siteSection = 'articles';
            break;
        case '/new-to-medicare/':
            break;
        case '/medicare/new-to-medicare/':
            break;
        case '/blog/':
            break;
        case '/online/blog/':
            pageName = 'home';
            break;
        case '/partner/':
            break;
        case '/online/partner/':
            siteSection = 'paidmedia';
            pageName = `partner: ${pageName}`;
            break;
        case '/enroll/large-group/':
            siteSection = 'online';
            pageName = 'enroll: large-group';
            break;
        case '/enroll/small-group/':
            siteSection = 'online';
            pageName = 'enroll: small-group';
            break;
    }

    if (pathName.indexOf('search') > -1) {
        // search results
        siteSection = 'searchresults';
    } else if (
        typeof document !== 'undefined' ? document.querySelector('body.single-post') : false
    ) {
        // articles
        siteSection = 'article';
    }

    return {
        pageName,
        siteSection,
    };
}

export const fireOpenModal = () => {
    if (typeof window !== 'undefined' && window._waEvents) {
        window._waEvents.push('openModal');
    }
};

export const fireCloseModal = () => {
    if (typeof window !== 'undefined' && window._waEvents) {
        window._waEvents.push('closeModal');
    }
};

export const fireTrackEvent = (payload: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && window._waEvents) {
        window._waEvents.push('trackEvent', payload);
    }
};

export const fireTrackLink = (payload: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && window._waEvents) {
        window._waEvents.push('trackLink', payload);
    }
};

export const firePageViewEvent = (payload: Record<string, unknown>) => {
    console.log('firePageViewEvent() ', payload);
    if (typeof window !== 'undefined' && window._waEvents) {
        console.log('window._waEvents ', window._waEvents);
        window._waEvents.push('pageView', { ...sessionContext, ...payload });
    }
};
